import React from 'react';
import { DeckPage } from './pages/DeckPage';
export function App() {
  return <DeckPage data-id="element-0" />;
}